import { createContext, useContext } from 'react'

export type AuthContextType = {
  token: string | null
  isAuthenticated: boolean
  login: (token: string) => void
  logOut: () => void
}

export const AuthContext = createContext<AuthContextType>({
  token: null,
  isAuthenticated: false,
  login: () => {},
  logOut: () => {},
})

export const useAuth = () => {
  return useContext(AuthContext)
}
